import { BitrixVue } from 'ui.vue';

import '../additionalRows/additionalRow1.js';
import '../additionalRows/additionalRow2.js';
import '../additionalRows/additionalRow3.js';

BitrixVue.component('AdditionalWrap', {
	data() {
		return {};
	},
	props: ['state', 'step'],
	template: `
	<div class="additional-wrap">
		<!--<AdditionalRow1 />-->
		<!--<AdditionalRow2 />-->
		<!--<AdditionalRow3 />-->
	</div>
`,
});
